import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { BlobServiceClient } from '@azure/storage-blob';
import './PSTUploadForm.css';

const PSTUploadForm = () => {
  const [selectedClient, setSelectedClient] = useState('');
  const [file, setFile] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'application/vnd.ms-outlook': ['.pst', '.pdf']
    },
    multiple: false,
    onDrop: (acceptedFiles) => setFile(acceptedFiles[0]),
  });

//   const uploadFile = async () => {
//   try {
//     setIsLoading(true);
//     setModalVisible(true);
//     setModalMessage("⏳ Uploading file... Please wait.");

//     const res = await fetch("https://pst-file-uploader.finkraftai.com/generate-sas-token");
//     const data = await res.json();
//     const sasToken = data.sasToken;

//     const accountName = "finkraftmain";
//     const containerName = "pst-files";
//     const blobName = file.name;

//     const s3url = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
//     const containerURL = `https://${accountName}.blob.core.windows.net/${containerName}?${sasToken}`;

//     const blobServiceClient = new BlobServiceClient(containerURL);
//     const containerClient = blobServiceClient.getContainerClient("");
//     const blockBlobClient = containerClient.getBlockBlobClient(blobName);

//     await blockBlobClient.uploadBrowserData(file, {
//       blockSize: 8 * 1024 * 1024,
//       concurrency: 2,
//     });

//     // ✅ Call backend API to log file upload
//     await fetch("https://pst-file-uploader.finkraftai.com/save-upload-log", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         client: selectedClient,
//         filename: file.name,
//         email: localStorage.getItem("email"), // You can change this if email comes from elsewhere
//         filesize: file.size,
//         s3url: s3url,
//       }),
//     });

//     setIsLoading(false);
//     setModalMessage("✅ File upload successful. Processing in background. You will receive an email once it's complete.");
//   } catch (err) {
//     console.error("Upload failed:", err);
//     setIsLoading(false);
//     setModalMessage("❌ Upload failed. Please try again.");
//   }
// };


const uploadFile = async () => {
  try {
    setIsLoading(true);
    setModalVisible(true);
    setModalMessage("⏳ Uploading file... Please wait.");

    const res = await fetch("https://pst-file-uploader.finkraftai.com/generate-sas-token");
    const data = await res.json();
    const sasToken = data.sasToken;

    const accountName = "finkraftmain";
    const containerName = "pst-files";
    const blobName = `${selectedClient}/${file.name}`; // <-- folder path

    const s3url = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
    const containerURL = `https://${accountName}.blob.core.windows.net/${containerName}?${sasToken}`;

    const blobServiceClient = new BlobServiceClient(containerURL);
    const containerClient = blobServiceClient.getContainerClient("");
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    await blockBlobClient.uploadBrowserData(file, {
      blockSize: 8 * 1024 * 1024,
      concurrency: 2,
    });

    // ✅ Log the upload in backend
    await fetch("https://pst-file-uploader.finkraftai.com/save-upload-log", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        client: selectedClient,
        filename: file.name,
        email: localStorage.getItem("userEmail"),
        filesize: file.size,
        s3url: s3url,
      }),
    });

    setIsLoading(false);
    setModalMessage("✅ File upload successful.");
  } catch (err) {
    console.error("Upload failed:", err);
    setIsLoading(false);
    setModalMessage("❌ Upload failed. Please try again.");
  }
};


  const handleUpload = () => {
    if (!selectedClient || !file) {
      setModalMessage("⚠️ Please select a client and a file before uploading.");
      setModalVisible(true);
      return;
    }
    uploadFile();
  };

  return (
    <div className="signup-form-container">
      <h2>PST Upload</h2>
      <p>Select client from the dropdown and upload PST.</p>

      <label>
        Client *
        <select value={selectedClient} onChange={(e) => setSelectedClient(e.target.value)} required>
          <option value="">Select client</option>
          <option value="wns">WNS</option>
          <option value="coca_cola">COCA COLA</option>
          <option value="fcm">FCM</option>
          <option value="happay">HAPPAY</option>
          <option value="red_bull">RED BULL</option>
          <option value="atpi">ATPI</option>
          <option value="ibrd">IBRD</option>
          <option value="astrazeneca">Astrazeneca</option>
          <option value="exl_services">Exl Services</option>
          <option value="others">Others</option>
        </select>
      </label>

      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>
          <span className="drop-text">Choose file</span> to upload.<br />
          Or drag and drop it here.
        </p>
      </div>

      {file && <p className="uploaded-file">📁 {file.name}</p>}

      <button onClick={handleUpload} className="submit-btn">Upload</button>

      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal">
            {isLoading && <div className="spinner"></div>}
            <p className="modal-message">{modalMessage}</p>
            {!isLoading && <button className="close-btn" onClick={() => setModalVisible(false)}>Close</button>}
          </div>
        </div>
      )}
    </div>
  );
};

export default PSTUploadForm;
